import { render, staticRenderFns } from "./AppleStoreIcon.vue?vue&type=template&id=010d8771"
import script from "./AppleStoreIcon.vue?vue&type=script&lang=js"
export * from "./AppleStoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports